import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { BaseGoogleAnalyticsCategory } from '../../base-google-analytics-category';

enum DetailAction {
  LOCK = 'lock',
  CLEAR = 'clear',
  IMAGE_DETAIL = 'image_detail',
  PIN = 'pin',
  COMPARE = 'compare',
  DOWNLOAD_FROM_DROPBOX = 'download_from_dropbox',
  COPY_URL = 'url',
  SHARE_ON_FACEBOOK = 'share_on_facebook',
  SHARE_ON_TWITTER = 'share_on_twitter',
  REPORT_CONTEXT_SOLR_SEARCH = 'report_context_solr_search'
}

export class Detail extends BaseGoogleAnalyticsCategory {
  constructor(ga: GoogleAnalyticsService, isEnabled: boolean) {
    super(ga, 'catalog_detail', isEnabled);
  }

  public lock() {
    this.event(DetailAction.LOCK);
  }

  public clear() {
    this.event(DetailAction.CLEAR);
  }

  public imageDetail(id: string) {
    this.event(DetailAction.IMAGE_DETAIL, id);
  }

  public pin(id: string) {
    this.event(DetailAction.PIN, id);
  }

  public compare(id: string) {
    this.event(DetailAction.COMPARE, id);
  }

  public downloadFromDropbox(id: string) {
    this.event(DetailAction.DOWNLOAD_FROM_DROPBOX, id);
  }

  public copyUrl(id: string) {
    this.event(DetailAction.COPY_URL, id);
  }

  public shareOnFacebook(id: string) {
    this.event(DetailAction.SHARE_ON_FACEBOOK, id);
  }

  public shareOnTwitter(id: string) {
    this.event(DetailAction.SHARE_ON_TWITTER, id);
  }

  public reportContextSolrSearch(id: string) {
    this.event(DetailAction.REPORT_CONTEXT_SOLR_SEARCH, id);
  }
}
